import type {Regal} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class ExemplarPlacementDataService {
    public static readonly serviceName = 'exemplarPlacementDataService';

    private static readonly EXEMPLAR_PLACEMENT_ROUTE = 'exemplar-placements';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getExemplarPlacement(exemplarId: number): Promise<Regal | undefined> {
        return this.ajaxService
            .createRequest(`${ExemplarPlacementDataService.EXEMPLAR_PLACEMENT_ROUTE}`)
            .get({exemplar: exemplarId});
    }
}
